<div class="numero_piezas">{{ numeroPiezas }}</div>
<div class="descripcion en-producción">EN PRODUCCIÓN</div>
